const CURRENCY_SYMBOLS = { USD: "$", EUR: "€", GBP: "£", THB: "฿", SGD: "S$" };

export const money = (amount, currency = "USD") => {
  const sym = CURRENCY_SYMBOLS[currency] || `${currency} `;
  const n = Number(amount || 0);
  return `${sym}${n.toFixed(2)}`;
};

export const PAYMENT_COLORS = {
  paid: "green",
  pending: "orange",
  failed: "red",
};

// Delivery orders keep the original shipping-oriented vocabulary; pickup
// orders (delivery_method === "pickup") use the collection-oriented one.
// Both sets share the same `order_status` column and "new"/"processing"
// values — only the label/color shown to the admin differs.
export const STATUS_COLORS = {
  new: "blue",
  processing: "gold",
  shipped: "cyan",
  completed: "green",
  cancelled: "red",
  ready_for_pickup: "purple",
  collected: "green",
};

export const STATUS_LABELS = {
  new: "New",
  processing: "Processing",
  shipped: "Shipped",
  completed: "Completed",
  cancelled: "Cancelled",
  ready_for_pickup: "Ready for Pickup",
  collected: "Collected",
};

export const PICKUP_STATUS_LABELS = {
  new: "Order Received",
  processing: "Preparing",
  ready_for_pickup: "Ready for Pickup",
  collected: "Collected",
  cancelled: "Cancelled",
};

export const isPickupOrder = (order) => order && order.delivery_method === "pickup";

export const getStatusLabel = (order) => {
  const status = order && order.order_status;
  if (isPickupOrder(order)) return PICKUP_STATUS_LABELS[status] || status || "-";
  return STATUS_LABELS[status] || status || "-";
};

// Status options offered in the admin dropdown, scoped to what makes sense
// for the order's delivery method (pickup orders never see "Shipped", for
// instance — see brief: "Do not process it as a shipment").
export const getStatusOptions = (order) => {
  if (isPickupOrder(order)) {
    return [
      { value: "new", label: "Order Received" },
      { value: "processing", label: "Preparing" },
      { value: "ready_for_pickup", label: "Ready for Pickup" },
      { value: "collected", label: "Collected" },
      { value: "cancelled", label: "Cancelled" },
    ];
  }
  return [
    { value: "new", label: "New" },
    { value: "processing", label: "Processing" },
    { value: "shipped", label: "Shipped" },
    { value: "completed", label: "Completed" },
    { value: "cancelled", label: "Cancelled" },
  ];
};
